import classnames from "classnames"

// TODO: Remove when the deprecated `color` prop is no longer in use.
type TextColor =
  | "brand"
  | "tint0"
  | "tint1"
  | "tint2"
  | "tint3"
  | "tint4"
  | "tint5"
  | "tint6"
  | "tint7"
  | "tint8"
  | "tint9"
  | "tint10"

export interface SubheadingProps {
  children?: React.ReactNode
  /** Overrides the default styles. (eg. "mb-2 mr-1" for margin) */
  className?: string
  /**
   * @deprecated Use the `className` prop with a color utility class
   * (eg. `className="c-tint2"`) instead. Confirm with UX if overriding the default color is necessary.
   */
  color?: TextColor
  /** Selects an h1-h5 HTML element. */
  level: 1 | 2 | 3 | 4 | 5
  /**
   * @deprecated Use `children` instead.
   */
  text?: string
}

const getColorClasses = (color: SubheadingProps["color"]) =>
  color ? `c-${color}` : undefined

export const Subheading = ({
  children,
  className,
  color,
  level,
  text,
}: SubheadingProps) => {
  const SubheadingTag = `h${level}` as keyof JSX.IntrinsicElements

  return (
    <SubheadingTag
      className={classnames(
        "dds-subheading",
        getColorClasses(color),
        className,
      )}
    >
      {children || text}
    </SubheadingTag>
  )
}
